<template>
<div>
  <!--<Navbar />-->
  <div class="content-i">
    <div class="content-box">
      <div class="element-wrapper">
        <h6 class="element-header">{{ t('disputesPageTitle', 'disputesPageTitle')}}</h6>
        <div class="element-box">
          <div class="element-info">
            <div class="row align-items-center">
              <div class="col-sm-8">
                <div class="element-info-with-icon">
                  <div class="element-info-icon">
                    <div class="os-icon os-icon-users">
                    </div>
                  </div>
                  <div class="element-info-text">
                    <h5 class="element-inner-header">{{ t('disputesPageHeader', 'disputesPageHeader')}}</h5>
                    <div class="element-inner-desc">{{ t('disputesPageDesc','disputesPageDesc') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 row mx-0 px-0">
            <div class="col-lg-2">
              <div class="form-group">
                <label for="event-type" class="d-block text-center">{{ t('disputesReasonSearchLabel','disputesReasonSearchLabel') }}</label>
                <select id="event-type" v-model="disputeRequest.reason" class="form-control custom-select text-capitalize">
                  <option :value="'all'" selected>{{t('selectAll','selectAll') }}</option>
                  <option v-for="reason in disputeReasons" :value="reason.id" :key="reason.id">{{ reason.status }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group">
                <label for="dispute-doc-ref" class="d-block text-center">{{ t('disputesDocRefSearchLabel','disputesDocRefSearchLabel') }}</label>
                <input id="dispute-doc-ref" v-model="disputeRequest.doc_reference" class="form-control" :placeholder="t('disputesSearchDocRefPlaceholder','disputesSearchDocRefPlaceholder')" type="text">
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group">
                <label for="dispute-cust-ref" class="d-block text-center">{{ t('disputesCustRefSearchLabel','disputesCustRefSearchLabel') }}</label>
                <input id="dispute-cust-ref" v-model="disputeRequest.cust_reference" class="form-control" :placeholder="t('disputesSearchCustRefPlaceholder','disputesSearchCustRefPlaceholder')" type="text">
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group">
                <label for="event-date-from" class="d-block text-center">{{ t('disputesSearchLabelEventDateFrom','disputesSearchLabelEventDateFrom') }}</label>
                <div class="date-input">
                  <!--<input id="event-date-from" v-model="logRequest.date_from" class="form-control" min="" :max="maxDate" type="date">-->
                  <datePicker id="event-date-from" v-model="disputeRequest.date_from" class="form-control text-center" :config="datePickerFromConfig"></datePicker>
                </div>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group">
                <label for="event-date-to" class="d-block text-center">{{ t('disputesSearchLabelEventDateTo','disputesSearchLabelEventDateTo') }}</label>
                <div class="date-input">
                  <datePicker id="event-date-to" v-model="disputeRequest.date_to" class="form-control text-center" :config="datePickerToConfig"></datePicker>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="controls-below-table pt-4" v-if="disputesList.length && disputesList">
            <div class="col-12 col-md-6 table-records-info">
              <p class="font-weight-bold mb-0">{{ disputesList.length }} {{ t('disputeEntriesFound','disputeEntriesFound') }}</p>
            </div>
            <div class="col-sm-12 col-md-4">
              <b-pagination class="float-right mb-0" v-model="currentPage" :total-rows="disputesList.length" :per-page="perPage" aria-controls="logs-table">
              </b-pagination>
            </div>
            <div class="col-sm-12 col-md-2 px-0">
              <b-input-group class="form-group col-lg-12 px-0 mb-1">
                <b-input-group-prepend>
                  <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                </b-input-group-prepend>
                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
              </b-input-group>
            </div>
          </div>
          <div class="col-12 mt-1 mb-2 px-0 text-right">
            <button :disabled="isBusy" class="btn btn-primary" type="button" @click="getDisputesList()">{{ t('searchDisputesBtn','searchDisputesBtn') }}</button>
          </div>
          <b-table id="disputes-table" striped hover bordered :fields="fields" :busy.sync="isBusy" :items="disputesList" :per-page="perPage" :currentPage="currentPage" :show-empty="rowEmpty">
            <template slot="empty" slot-scope="items" >
              <span>{{ t('disputesNoEntries','disputesNoEntries') }}</span>
            </template>
            <template v-slot:cell(id)="data">
              <span>{{ data.item.id }}</span>
            </template>
            <template v-slot:cell(document_reference)="data">
              <span>{{ data.item.document_reference }}</span>
            </template>
            <template v-slot:cell(customer_reference)="data">
              <span>{{ data.item.customer_reference }}</span>
            </template>
            <template v-slot:cell(dispute_reason)="data">
              <span>{{ data.item.dispute_reason }}</span>
            </template>
            <template v-slot:cell(notes)="data">
              <span>{{ data.item.notes }}</span>
            </template>
            <template v-slot:cell(last_update)="data">
              <span>{{ data.item.last_update }}</span>
            </template>
          </b-table>
          <div class="controls-below-table pt-1" v-if="disputesList &&disputesList.length">
            <div class="col-12 col-md-6 table-records-info">
              <p class="font-weight-bold mb-0">{{ disputesList.length }} {{ t('disputeEntriesFound','disputeEntriesFound') }}</p>
            </div>
            <div class="col-sm-12 col-md-4">
              <b-pagination class="float-right mb-0" v-model="currentPage" :total-rows="disputesList.length" :per-page="perPage" aria-controls="logs-table">
              </b-pagination>
            </div>
            <div class="col-sm-12 col-md-2 px-0">
              <b-input-group class="form-group col-lg-12 px-0">
                <b-input-group-prepend>
                  <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                </b-input-group-prepend>
                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
              </b-input-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Navbar from '@/components/Navbar'
import { mapGetters } from 'vuex'
import moment from 'moment'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { VclTable } from 'vue-content-loading'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

export default {
    name: 'Disputes',
    components:{
        Navbar,
        VclTable,
        datePicker
    },
    data () {
      return {
        fields: [
            //{key: 'id', label: 'ID', sortable: true, thClass: 'hover-pointer brand-color'},
            {key: 'document_reference', label: this.t('docReferenceTableHeader', 'docReferenceTableHeader'), sortable: false, thClass: 'hover-pointer brand-color'},
            {key: 'customer_reference', label: this.t('custReferenceTableHeader', 'custReferenceTableHeader'), sortable: false, thClass: 'hover-pointer brand-color'},
            {key: 'dispute_reason', label: this.t('disputeReasonTableHeader', 'disputeReasonTableHeader'), sortable: false, thClass: 'hover-pointer brand-color'},
            {key: 'notes', label: this.t('disputeNotesTableHeader', 'disputeNotesTableHeader'), sortable: false, thClass: 'brand-color'},
            {key: 'last_update', label: this.t('disputeDateTableHeader', 'disputeDateTableHeader'), sortable: false, thClass: 'brand-color'}
        ],
        currentPage: 1,
        perPage: 20,
        pageOptions: [10, 20, 50, 100],
        disputesList: [],
        filter: null,
        disputeRequest: {},
        isBusy: false,
        disputeReasons: null,
        datePickerFromConfig: {
          icons: {
            time: 'os-icon os-icon-calendar-time',
            date: 'os-icon os-icon-basic-2-259-calendar',
            up: 'os-icon os-icon-chevron-up',
            down: 'os-icon os-icon-chevron-down',
            previous: 'os-icon os-icon-chevron-left',
            next: 'os-icon os-icon-chevron-right',
            clear: 'os-icon os-icon-trash',
            close: 'os-icon os-icon-cancel-circle'
          },
          minDate: moment('1979-01-01', this.datePickerFormat),
          maxDate: moment(new Date(), this.datePickerFormat),
          showClear: true
        },
        datePickerToConfig: {
          icons: {
            time: 'os-icon os-icon-calendar-time',
            date: 'os-icon os-icon-basic-2-259-calendar',
            up: 'os-icon os-icon-chevron-up',
            down: 'os-icon os-icon-chevron-down',
            previous: 'os-icon os-icon-chevron-left',
            next: 'os-icon os-icon-chevron-right',
            clear: 'os-icon os-icon-trash',
            close: 'os-icon os-icon-cancel-circle'
          },
          maxDate: moment(new Date(), this.datePickerFormat),
          minDate: moment('1979-01-01', this.datePickerFormat),
          showClear: true
        },
        rowEmpty: false
      }
    },
    methods: {
      getDisputesList() {
        this.isBusy = true

        Object.keys(this.disputeRequest).forEach((key) => (this.disputeRequest[key] == '') && (this.disputeRequest[key] = undefined))
        this.$router.push({ query: { ...this.$route.query, ...this.disputeRequest, page: this.currentPage, per_page: this.perPage } })

        let customersAllowed = null
        if(this.$store.getters.getUserDetails.user_scf_customer) {
          customersAllowed = this.$store.getters.getUserDetails.user_scf_customer
        }

        this.$store.dispatch('disputeStore/getDisputesList', {
          perPage: this.perPage,
          currentPage: this.currentPage,
          userLevel: this.$store.getters.getUserLevel,
          date_from : this.disputeRequest.date_from,
          date_to : this.disputeRequest.date_to,
          doc_reference : this.disputeRequest.doc_reference,
          cust_reference: this.disputeRequest.cust_reference,
          reason: this.disputeRequest.reason
        })
        .then(response => {
            this.isBusy = false
            this.disputesList = response.disputes

            if((this.disputesList === undefined) || (this.disputesList.length == 0) || !this.disputesList) {
              this.rowEmpty = true
            }
            
        }, this)
      },

      getDisputeReasons() {
        this.$store.dispatch('disputeStore/getDisputeReasons', null)
        .then(response => {
            this.isBusy = false
            if(response) {
              this.disputeReasons = response
            }
        }, this)
      }
    },
    computed:{
      datePickerFormat: {
        get() {
          if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
            let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
            return dateformat
          } else {
            return "MM-DD-YYYY"
          }
          
        }
      },
    },
    created() {
      if(Object.keys(this.$route.query).length){
          this.disputeRequest = Object.assign({}, this.$route.query)

          if(this.$route.query.page) {
            this.currentPage = this.$route.query.page
          }
          if(this.$route.query.per_page) {
            this.perPage = this.$route.query.per_page
          }
      }

      this.getDisputesList()
      this.getDisputeReasons()
    }
}

</script>

<style scoped>
  table >>> tbody, table >>> thead{
    text-align: center;
  }
  .table  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
</style>
